import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	unresolved: {
		id: 'native-issue-table.common.issue-cells.resolution.unresolved',
		defaultMessage: 'Unresolved',
		description: 'Displayed string when resolution is unresolved',
	},
});
